export default __webpack_public_path__ + "static/media/ced-greentech.d6f3d3d6.png";